var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomePageImage3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3030,
    height: 2258,
    viewBox: "0 0 3030 2258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1559.95 1431.29V1430.87V1430.29V1429.95V1314H1430L1430 1430.29V1430.76V1431V1431.48V1439.22V1439.62L1430 1444H1560L1559.95 1431.29Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1544.96 1419.22V1418.9V1418.45V1418.19V1329H1445L1445 1418.45V1418.82V1419V1419.37V1425.32V1425.63L1445 1429H1545L1544.96 1419.22Z",
    fill: "url(#paint0_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1819.95 1301.29V1300.87V1300.29V1299.95V1184H1690L1690 1300.29V1300.76V1301V1301.48V1309.22V1309.62L1690 1314H1820L1819.95 1301.29Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1804.96 1289.22V1288.9V1288.45V1288.19V1199H1705L1705 1288.45V1288.82V1289V1289.37V1295.32V1295.63L1705 1299H1805L1804.96 1289.22Z",
    fill: "url(#paint1_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1689.95 1301.29V1300.87V1300.29V1299.95V1184H1560L1560 1300.29V1300.76V1301V1301.48V1309.22V1309.62L1560 1314H1690L1689.95 1301.29Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1674.96 1289.22V1288.9V1288.45V1288.19V1199H1575L1575 1288.45V1288.82V1289V1289.37V1295.32V1295.63L1575 1299H1675L1674.96 1289.22Z",
    fill: "url(#paint2_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1559.95 1301.29V1300.87V1300.29V1299.95V1184H1430L1430 1300.29V1300.76V1301V1301.48V1309.22V1309.62L1430 1314H1560L1559.95 1301.29Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1544.96 1289.22V1288.9V1288.45V1288.19V1199H1445L1445 1288.45V1288.82V1289V1289.37V1295.32V1295.63L1445 1299H1545L1544.96 1289.22Z",
    fill: "url(#paint3_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1559.95 1561.29V1560.87V1560.29V1559.95V1444H1430L1430 1560.29V1560.76V1561V1561.48V1569.22V1569.62L1430 1574H1560L1559.95 1561.29Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1544.96 1549.22V1548.9V1548.45V1548.19V1459H1445L1445 1548.45V1548.82V1549V1549.37V1555.32V1555.63L1445 1559H1545L1544.96 1549.22Z",
    fill: "url(#paint4_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1429.95 1301.29V1300.87V1300.29V1299.95V1184H1300L1300 1300.29V1300.76V1301V1301.48V1309.22V1309.62L1300 1314H1430L1429.95 1301.29Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1414.96 1289.22V1288.9V1288.45V1288.19V1199H1315L1315 1288.45V1288.82V1289V1289.37V1295.32V1295.63L1315 1299H1415L1414.96 1289.22Z",
    fill: "url(#paint5_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1559.95 1691.29V1690.87V1690.29V1689.95V1574H1430L1430 1690.29V1690.76V1691V1691.48V1699.22V1699.62L1430 1704H1560L1559.95 1691.29Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1544.96 1679.22V1678.9V1678.45V1678.19V1589H1445L1445 1678.45V1678.82V1679V1679.37V1685.32V1685.63L1445 1689H1545L1544.96 1679.22Z",
    fill: "url(#paint6_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1949.95 1301.29V1300.87V1300.29V1299.95V1184H1820L1820 1300.29V1300.76V1301V1301.48V1309.22V1309.62L1820 1314H1950L1949.95 1301.29Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1934.96 1289.22V1288.9V1288.45V1288.19V1199H1835L1835 1288.45V1288.82V1289V1289.37V1295.32V1295.63L1835 1299H1935L1934.96 1289.22Z",
    fill: "url(#paint7_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M869.95 647.29V646.875V646.285V645.946V530H740L740 646.285V646.764V647.003V647.482V655.219V655.619L740 660H870L869.95 647.29Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M854.962 635.223V634.904V634.45V634.189V545H755L755 634.45V634.818V635.002V635.371V641.322V641.63L755 645H855L854.962 635.223Z",
    fill: "url(#paint8_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M869.95 517.29V516.875V516.285V515.946V400H740L740 516.285V516.764V517.003V517.482V525.219V525.619L740 530H870L869.95 517.29Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M854.962 505.223V504.904V504.45V504.189V415H755L755 504.45V504.818V505.002V505.371V511.322V511.63L755 515H855L854.962 505.223Z",
    fill: "url(#paint9_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M869.95 777.29V776.875V776.285V775.946V660H740L740 776.285V776.764V777.003V777.482V785.219V785.619L740 790H870L869.95 777.29Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M854.962 765.223V764.904V764.45V764.189V675H755L755 764.45V764.818V765.002V765.371V771.322V771.63L755 775H855L854.962 765.223Z",
    fill: "url(#paint10_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M739.95 517.29V516.875V516.285V515.946V400H610L610 516.285V516.764V517.003V517.482V525.219V525.619L610 530H740L739.95 517.29Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M724.962 505.223V504.904V504.45V504.189V415H625L625 504.45V504.818V505.002V505.371V511.322V511.63L625 515H725L724.962 505.223Z",
    fill: "url(#paint11_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M247.29 1998.05H246.875H246.285H245.946H130L130 2128L246.285 2128H246.764H247.003H247.482H255.219H255.619L260 2128V1998L247.29 1998.05Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.223 2013.04H234.904H234.45H234.189H145V2113L234.45 2113H234.818H235.002H235.371H241.322H241.63L245 2113L245 2013L235.223 2013.04Z",
    fill: "url(#paint12_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.29 1738.05H116.875H116.285H115.946H2.60425e-06L2.60425e-06 1868L116.285 1868H116.764H117.003H117.482H125.219H125.619L130 1868L130 1738L117.29 1738.05Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.223 1753.04H104.904H104.45H104.189H15L15 1853L104.45 1853H104.818H105.002H105.371H111.322H111.63L115 1853L115 1753L105.223 1753.04Z",
    fill: "url(#paint13_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.29 1868.05H116.875H116.285H115.946H2.60425e-06L2.60425e-06 1998L116.285 1998H116.764H117.003H117.482H125.219H125.619L130 1998L130 1868L117.29 1868.05Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.223 1883.04H104.904H104.45H104.189H15L15 1983L104.45 1983H104.818H105.002H105.371H111.322H111.63L115 1983L115 1883L105.223 1883.04Z",
    fill: "url(#paint14_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.29 1998.05H116.875H116.285H115.946H2.60425e-06L2.60425e-06 2128L116.285 2128H116.764H117.003H117.482H125.219H125.619L130 2128L130 1998L117.29 1998.05Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.223 2013.04H104.904H104.45H104.189H15L15 2113L104.45 2113H104.818H105.002H105.371H111.322H111.63L115 2113L115 2013L105.223 2013.04Z",
    fill: "url(#paint15_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M377.29 1998.05H376.875H376.285H375.946H260V2128L376.285 2128H376.764H377.003H377.482H385.219H385.619L390 2128V1998L377.29 1998.05Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.223 2013.04H364.904H364.45H364.189H275V2113L364.45 2113H364.818H365.002H365.371H371.322H371.63L375 2113V2013L365.223 2013.04Z",
    fill: "url(#paint16_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.29 2128.05H116.875H116.285H115.946H2.60425e-06L2.60425e-06 2258L116.285 2258H116.764H117.003H117.482H125.219H125.619L130 2258L130 2128L117.29 2128.05Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.223 2143.04H104.904H104.45H104.189H15L15 2243L104.45 2243H104.818H105.002H105.371H111.322H111.63L115 2243L115 2143L105.223 2143.04Z",
    fill: "url(#paint17_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M507.29 1998.05H506.875H506.285H505.946H390V2128L506.285 2128H506.764H507.003H507.482H515.219H515.619L520 2128V1998L507.29 1998.05Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M495.223 2013.04H494.904H494.45H494.189H405V2113L494.45 2113H494.818H495.002H495.371H501.322H501.63L505 2113V2013L495.223 2013.04Z",
    fill: "url(#paint18_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.29 1608.05H116.875H116.285H115.946H2.60425e-06L2.60425e-06 1738L116.285 1738H116.764H117.003H117.482H125.219H125.619L130 1738L130 1608L117.29 1608.05Z",
    fill: "#14ADC6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.223 1623.04H104.904H104.45H104.189H15L15 1723L104.45 1723H104.818H105.002H105.371H111.322H111.63L115 1723L115 1623L105.223 1623.04Z",
    fill: "url(#paint19_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1689.95 1691.29V1690.87V1690.29V1689.95V1574H1560L1560 1690.29V1690.76V1691V1691.48V1699.22V1699.62L1560 1704H1690L1689.95 1691.29Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1674.96 1679.22V1678.9V1678.45V1678.19V1589H1575L1575 1678.45V1678.82V1679V1679.37V1685.32V1685.63L1575 1689H1675L1674.96 1679.22Z",
    fill: "url(#paint20_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1819.95 1691.29V1690.87V1690.29V1689.95V1574H1690L1690 1690.29V1690.76V1691V1691.48V1699.22V1699.62L1690 1704H1820L1819.95 1691.29Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1804.96 1679.22V1678.9V1678.45V1678.19V1589H1705L1705 1678.45V1678.82V1679V1679.37V1685.32V1685.63L1705 1689H1805L1804.96 1679.22Z",
    fill: "url(#paint21_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1949.95 1691.29V1690.87V1690.29V1689.95V1574H1820L1820 1690.29V1690.76V1691V1691.48V1699.22V1699.62L1820 1704H1950L1949.95 1691.29Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1934.96 1679.22V1678.9V1678.45V1678.19V1589H1835L1835 1678.45V1678.82V1679V1679.37V1685.32V1685.63L1835 1689H1935L1934.96 1679.22Z",
    fill: "url(#paint22_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2079.95 1691.29V1690.87V1690.29V1689.95V1574H1950L1950 1690.29V1690.76V1691V1691.48V1699.22V1699.62L1950 1704H2080L2079.95 1691.29Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2064.96 1679.22V1678.9V1678.45V1678.19V1589H1965L1965 1678.45V1678.82V1679V1679.37V1685.32V1685.63L1965 1689H2065L2064.96 1679.22Z",
    fill: "url(#paint23_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1819.95 1821.29V1820.87V1820.29V1819.95V1704H1690L1690 1820.29V1820.76V1821V1821.48V1829.22V1829.62L1690 1834H1820L1819.95 1821.29Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1804.96 1809.22V1808.9V1808.45V1808.19V1719H1705L1705 1808.45V1808.82V1809V1809.37V1815.32V1815.63L1705 1819H1805L1804.96 1809.22Z",
    fill: "url(#paint24_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1949.95 1821.29V1820.87V1820.29V1819.95V1704H1820L1820 1820.29V1820.76V1821V1821.48V1829.22V1829.62L1820 1834H1950L1949.95 1821.29Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1934.96 1809.22V1808.9V1808.45V1808.19V1719H1835L1835 1808.45V1808.82V1809V1809.37V1815.32V1815.63L1835 1819H1935L1934.96 1809.22Z",
    fill: "url(#paint25_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2757.29 390.05H2756.87H2756.29H2755.95H2640V520L2756.29 520H2756.76H2757H2757.48H2765.22H2765.62L2770 520V390L2757.29 390.05Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2745.22 405.038H2744.9H2744.45H2744.19H2655V505L2744.45 505H2744.82H2745H2745.37H2751.32H2751.63L2755 505V405L2745.22 405.038Z",
    fill: "url(#paint26_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2757.29 260.05H2756.87H2756.29H2755.95H2640V390L2756.29 390H2756.76H2757H2757.48H2765.22H2765.62L2770 390V260L2757.29 260.05Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2745.22 275.038H2744.9H2744.45H2744.19H2655V375L2744.45 375H2744.82H2745H2745.37H2751.32H2751.63L2755 375V275L2745.22 275.038Z",
    fill: "url(#paint27_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2757.29 130.05H2756.87H2756.29H2755.95H2640V260L2756.29 260H2756.76H2757H2757.48H2765.22H2765.62L2770 260V130L2757.29 130.05Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2745.22 145.038H2744.9H2744.45H2744.19H2655V245L2744.45 245H2744.82H2745H2745.37H2751.32H2751.63L2755 245V145L2745.22 145.038Z",
    fill: "url(#paint28_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2757.29 0.0497915H2756.87H2756.29H2755.95H2640V130L2756.29 130H2756.76H2757H2757.48H2765.22H2765.62L2770 130V1.77673e-06L2757.29 0.0497915Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2745.22 15.0383H2744.9H2744.45H2744.19H2655V115L2744.45 115H2744.82H2745H2745.37H2751.32H2751.63L2755 115V15L2745.22 15.0383Z",
    fill: "url(#paint29_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2887.29 260.05H2886.87H2886.29H2885.95H2770V390L2886.29 390H2886.76H2887H2887.48H2895.22H2895.62L2900 390V260L2887.29 260.05Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2875.22 275.038H2874.9H2874.45H2874.19H2785V375L2874.45 375H2874.82H2875H2875.37H2881.32H2881.63L2885 375V275L2875.22 275.038Z",
    fill: "url(#paint30_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3017.29 260.05H3016.87H3016.29H3015.95H2900V390L3016.29 390H3016.76H3017H3017.48H3025.22H3025.62L3030 390V260L3017.29 260.05Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3005.22 275.038H3004.9H3004.45H3004.19H2915V375L3004.45 375H3004.82H3005H3005.37H3011.32H3011.63L3015 375V275L3005.22 275.038Z",
    fill: "url(#paint31_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2887.29 130.05H2886.87H2886.29H2885.95H2770V260L2886.29 260H2886.76H2887H2887.48H2895.22H2895.62L2900 260V130L2887.29 130.05Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter32_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2875.22 145.038H2874.9H2874.45H2874.19H2785V245L2874.45 245H2874.82H2875H2875.37H2881.32H2881.63L2885 245V145L2875.22 145.038Z",
    fill: "url(#paint32_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3017.29 130.05H3016.87H3016.29H3015.95H2900V260L3016.29 260H3016.76H3017H3017.48H3025.22H3025.62L3030 260V130L3017.29 130.05Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter33_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3005.22 145.038H3004.9H3004.45H3004.19H2915V245L3004.45 245H3004.82H3005H3005.37H3011.32H3011.63L3015 245V145L3005.22 145.038Z",
    fill: "url(#paint33_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M519.95 1985.29V1984.87V1984.29V1983.95V1868H390L390 1984.29V1984.76V1985V1985.48V1993.22V1993.62L390 1998H520L519.95 1985.29Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter34_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M504.962 1973.22V1972.9V1972.45V1972.19V1883H405L405 1972.45V1972.82V1973V1973.37V1979.32V1979.63L405 1983H505L504.962 1973.22Z",
    fill: "url(#paint34_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M649.95 1985.29V1984.87V1984.29V1983.95V1868H520L520 1984.29V1984.76V1985V1985.48V1993.22V1993.62L520 1998H650L649.95 1985.29Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter35_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M634.962 1973.22V1972.9V1972.45V1972.19V1883H535L535 1972.45V1972.82V1973V1973.37V1979.32V1979.63L535 1983H635L634.962 1973.22Z",
    fill: "url(#paint35_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M779.95 1985.29V1984.87V1984.29V1983.95V1868H650L650 1984.29V1984.76V1985V1985.48V1993.22V1993.62L650 1998H780L779.95 1985.29Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter36_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M764.962 1973.22V1972.9V1972.45V1972.19V1883H665L665 1972.45V1972.82V1973V1973.37V1979.32V1979.63L665 1983H765L764.962 1973.22Z",
    fill: "url(#paint36_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M649.95 2115.29V2114.87V2114.29V2113.95V1998H520L520 2114.29V2114.76V2115V2115.48V2123.22V2123.62L520 2128H650L649.95 2115.29Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter37_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M634.962 2103.22V2102.9V2102.45V2102.19V2013H535L535 2102.45V2102.82V2103V2103.37V2109.32V2109.63L535 2113H635L634.962 2103.22Z",
    fill: "url(#paint37_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M779.95 2115.29V2114.87V2114.29V2113.95V1998H650L650 2114.29V2114.76V2115V2115.48V2123.22V2123.62L650 2128H780L779.95 2115.29Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter38_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M764.962 2103.22V2102.9V2102.45V2102.19V2013H665L665 2102.45V2102.82V2103V2103.37V2109.32V2109.63L665 2113H765L764.962 2103.22Z",
    fill: "url(#paint38_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1169.95 857.29V856.875V856.285V855.946V740H1040L1040 856.285V856.764V857.003V857.482V865.219V865.619L1040 870H1170L1169.95 857.29Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter39_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1154.96 845.223V844.904V844.45V844.189V755H1055L1055 844.45V844.818V845.002V845.371V851.322V851.63L1055 855H1155L1154.96 845.223Z",
    fill: "url(#paint39_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1299.95 857.29V856.875V856.285V855.946V740H1170L1170 856.285V856.764V857.003V857.482V865.219V865.619L1170 870H1300L1299.95 857.29Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter40_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1284.96 845.223V844.904V844.45V844.189V755H1185L1185 844.45V844.818V845.002V845.371V851.322V851.63L1185 855H1285L1284.96 845.223Z",
    fill: "url(#paint40_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1429.95 857.29V856.875V856.285V855.946V740H1300L1300 856.285V856.764V857.003V857.482V865.219V865.619L1300 870H1430L1429.95 857.29Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter41_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1414.96 845.223V844.904V844.45V844.189V755H1315L1315 844.45V844.818V845.002V845.371V851.322V851.63L1315 855H1415L1414.96 845.223Z",
    fill: "url(#paint41_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1299.95 987.29V986.875V986.285V985.946V870H1170L1170 986.285V986.764V987.003V987.482V995.219V995.619L1170 1000H1300L1299.95 987.29Z",
    fill: "#94C11F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter42_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1284.96 975.223V974.904V974.45V974.189V885H1185L1185 974.45V974.818V975.002V975.371V981.322V981.63L1185 985H1285L1284.96 975.223Z",
    fill: "url(#paint42_radial_606_2)",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1689.95 2115.29V2114.87V2114.29V2113.95V1998H1560L1560 2114.29V2114.76V2115V2115.48V2123.22V2123.62L1560 2128H1690L1689.95 2115.29Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter43_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1674.96 2103.22V2102.9V2102.45V2102.19V2013H1575L1575 2102.45V2102.82V2103V2103.37V2109.32V2109.63L1575 2113H1675L1674.96 2103.22Z",
    fill: "url(#paint43_radial_606_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1689.95 1855.29V1854.87V1854.29V1853.95V1738H1560L1560 1854.29V1854.76V1855V1855.48V1863.22V1863.62L1560 1868H1690L1689.95 1855.29Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter44_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1674.96 1843.22V1842.9V1842.45V1842.19V1753H1575L1575 1842.45V1842.82V1843V1843.37V1849.32V1849.63L1575 1853H1675L1674.96 1843.22Z",
    fill: "url(#paint44_radial_606_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1689.95 1985.29V1984.87V1984.29V1983.95V1868H1560L1560 1984.29V1984.76V1985V1985.48V1993.22V1993.62L1560 1998H1690L1689.95 1985.29Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter45_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1674.96 1973.22V1972.9V1972.45V1972.19V1883H1575L1575 1972.45V1972.82V1973V1973.37V1979.32V1979.63L1575 1983H1675L1674.96 1973.22Z",
    fill: "url(#paint45_radial_606_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1299.95 2245.29V2244.87V2244.29V2243.95V2128H1170L1170 2244.29V2244.76V2245V2245.48V2253.22V2253.62L1170 2258H1300L1299.95 2245.29Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter46_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1284.96 2233.22V2232.9V2232.45V2232.19V2143H1185L1185 2232.45V2232.82V2233V2233.37V2239.32V2239.63L1185 2243H1285L1284.96 2233.22Z",
    fill: "url(#paint46_radial_606_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1429.95 2245.29V2244.87V2244.29V2243.95V2128H1300L1300 2244.29V2244.76V2245V2245.48V2253.22V2253.62L1300 2258H1430L1429.95 2245.29Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter47_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1414.96 2233.22V2232.9V2232.45V2232.19V2143H1315L1315 2232.45V2232.82V2233V2233.37V2239.32V2239.63L1315 2243H1415L1414.96 2233.22Z",
    fill: "url(#paint47_radial_606_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1559.95 2245.29V2244.87V2244.29V2243.95V2128H1430L1430 2244.29V2244.76V2245V2245.48V2253.22V2253.62L1430 2258H1560L1559.95 2245.29Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter48_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1544.96 2233.22V2232.9V2232.45V2232.19V2143H1445L1445 2232.45V2232.82V2233V2233.37V2239.32V2239.63L1445 2243H1545L1544.96 2233.22Z",
    fill: "url(#paint48_radial_606_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1817.95 2245.29V2244.87V2244.29V2243.95V2128H1688L1688 2244.29V2244.76V2245V2245.48V2253.22V2253.62L1688 2258H1818L1817.95 2245.29Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter49_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1802.96 2233.22V2232.9V2232.45V2232.19V2143H1703L1703 2232.45V2232.82V2233V2233.37V2239.32V2239.63L1703 2243H1803L1802.96 2233.22Z",
    fill: "url(#paint49_radial_606_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1689.95 2245.29V2244.87V2244.29V2243.95V2128H1560L1560 2244.29V2244.76V2245V2245.48V2253.22V2253.62L1560 2258H1690L1689.95 2245.29Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter50_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1674.96 2233.22V2232.9V2232.45V2232.19V2143H1575L1575 2232.45V2232.82V2233V2233.37V2239.32V2239.63L1575 2243H1675L1674.96 2233.22Z",
    fill: "url(#paint50_radial_606_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M507.29 1309.95H506.875H506.285H505.946H390V1180L506.285 1180H506.764H507.003H507.482H515.219H515.619L520 1180V1310L507.29 1309.95Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter51_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M495.223 1294.96H494.904H494.45H494.189H405V1195L494.45 1195H494.818H495.002H495.371H501.322H501.63L505 1195V1295L495.223 1294.96Z",
    fill: "url(#paint51_radial_606_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M247.29 1309.95H246.875H246.285H245.946H130V1180L246.285 1180H246.764H247.003H247.482H255.219H255.619L260 1180V1310L247.29 1309.95Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter52_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.223 1294.96H234.904H234.45H234.189H145V1195L234.45 1195H234.818H235.002H235.371H241.322H241.63L245 1195V1295L235.223 1294.96Z",
    fill: "url(#paint52_radial_606_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M377.29 1309.95H376.875H376.285H375.946H260V1180L376.285 1180H376.764H377.003H377.482H385.219H385.619L390 1180V1310L377.29 1309.95Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter53_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.223 1294.96H364.904H364.45H364.189H275V1195L364.45 1195H364.818H365.002H365.371H371.322H371.63L375 1195V1295L365.223 1294.96Z",
    fill: "url(#paint53_radial_606_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M637.29 919.95H636.875H636.285H635.946H520V790L636.285 790H636.764H637.003H637.482H645.219H645.619L650 790V920L637.29 919.95Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter54_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M625.223 904.962H624.904H624.45H624.189H535V805L624.45 805H624.818H625.002H625.371H631.322H631.63L635 805V905L625.223 904.962Z",
    fill: "url(#paint54_radial_606_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M637.29 1049.95H636.875H636.285H635.946H520V920L636.285 920H636.764H637.003H637.482H645.219H645.619L650 920V1050L637.29 1049.95Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter55_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M625.223 1034.96H624.904H624.45H624.189H535V935L624.45 935H624.818H625.002H625.371H631.322H631.63L635 935V1035L625.223 1034.96Z",
    fill: "url(#paint55_radial_606_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M637.29 1179.95H636.875H636.285H635.946H520V1050L636.285 1050H636.764H637.003H637.482H645.219H645.619L650 1050V1180L637.29 1179.95Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter56_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M625.223 1164.96H624.904H624.45H624.189H535V1065L624.45 1065H624.818H625.002H625.371H631.322H631.63L635 1065V1165L625.223 1164.96Z",
    fill: "url(#paint56_radial_606_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M637.29 1437.95H636.875H636.285H635.946H520V1308L636.285 1308H636.764H637.003H637.482H645.219H645.619L650 1308V1438L637.29 1437.95Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter57_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M625.223 1422.96H624.904H624.45H624.189H535V1323L624.45 1323H624.818H625.002H625.371H631.322H631.63L635 1323V1423L625.223 1422.96Z",
    fill: "url(#paint57_radial_606_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M637.29 1309.95H636.875H636.285H635.946H520V1180L636.285 1180H636.764H637.003H637.482H645.219H645.619L650 1180V1310L637.29 1309.95Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter58_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M625.223 1294.96H624.904H624.45H624.189H535V1195L624.45 1195H624.818H625.002H625.371H631.322H631.63L635 1195V1295L625.223 1294.96Z",
    fill: "url(#paint58_radial_606_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1039.95 1620.71V1621.13V1621.71V1622.05V1738H910L910 1621.71V1621.24V1621V1620.52V1612.78V1612.38L910 1608H1040L1039.95 1620.71Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter59_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1024.96 1632.78V1633.1V1633.55V1633.81V1723H925L925 1633.55V1633.18V1633V1632.63V1626.68V1626.37L925 1623H1025L1024.96 1632.78Z",
    fill: "url(#paint59_radial_606_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M909.95 1750.71V1751.13V1751.71V1752.05V1868H780L780 1751.71V1751.24V1751V1750.52V1742.78V1742.38L780 1738H910L909.95 1750.71Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter60_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M894.962 1762.78V1763.1V1763.55V1763.81V1853H795L795 1763.55V1763.18V1763V1762.63V1756.68V1756.37L795 1753H895L894.962 1762.78Z",
    fill: "url(#paint60_radial_606_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1039.95 1750.71V1751.13V1751.71V1752.05V1868H910L910 1751.71V1751.24V1751V1750.52V1742.78V1742.38L910 1738H1040L1039.95 1750.71Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter61_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1024.96 1762.78V1763.1V1763.55V1763.81V1853H925L925 1763.55V1763.18V1763V1762.63V1756.68V1756.37L925 1753H1025L1024.96 1762.78Z",
    fill: "url(#paint61_radial_606_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1169.95 1490.71V1491.13V1491.71V1492.05V1608H1040L1040 1491.71V1491.24V1491V1490.52V1482.78V1482.38L1040 1478H1170L1169.95 1490.71Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter62_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1154.96 1502.78V1503.1V1503.55V1503.81V1593H1055L1055 1503.55V1503.18V1503V1502.63V1496.68V1496.37L1055 1493H1155L1154.96 1502.78Z",
    fill: "url(#paint62_radial_606_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1039.95 1490.71V1491.13V1491.71V1492.05V1608H910L910 1491.71V1491.24V1491V1490.52V1482.78V1482.38L910 1478H1040L1039.95 1490.71Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter63_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1024.96 1502.78V1503.1V1503.55V1503.81V1593H925L925 1503.55V1503.18V1503V1502.63V1496.68V1496.37L925 1493H1025L1024.96 1502.78Z",
    fill: "url(#paint63_radial_606_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1979.95 842.71V843.125V843.715V844.054V960H1850L1850 843.715V843.236V842.997V842.518V834.781V834.381L1850 830H1980L1979.95 842.71Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter64_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1964.96 854.777V855.096V855.55V855.811V945H1865L1865 855.55V855.182V854.998V854.629V848.678V848.37L1865 845H1965L1964.96 854.777Z",
    fill: "url(#paint64_radial_606_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1849.95 972.71V973.125V973.715V974.054V1090H1720L1720 973.715V973.236V972.997V972.518V964.781V964.381L1720 960H1850L1849.95 972.71Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter65_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1834.96 984.777V985.096V985.55V985.811V1075H1735L1735 985.55V985.182V984.998V984.629V978.678V978.37L1735 975H1835L1834.96 984.777Z",
    fill: "url(#paint65_radial_606_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1979.95 972.71V973.125V973.715V974.054V1090H1850L1850 973.715V973.236V972.997V972.518V964.781V964.381L1850 960H1980L1979.95 972.71Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter66_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1964.96 984.777V985.096V985.55V985.811V1075H1865L1865 985.55V985.182V984.998V984.629V978.678V978.37L1865 975H1965L1964.96 984.777Z",
    fill: "url(#paint66_radial_606_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1849.95 842.71V843.125V843.715V844.054V960H1720L1720 843.715V843.236V842.997V842.518V834.781V834.381L1720 830H1850L1849.95 842.71Z",
    fill: "#E71E73"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter67_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1834.96 854.777V855.096V855.55V855.811V945H1735L1735 855.55V855.182V854.998V854.629V848.678V848.37L1735 845H1835L1834.96 854.777Z",
    fill: "url(#paint67_radial_606_2)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M389.95 1592.29V1591.87V1591.29V1590.95V1475H260L260 1591.29V1591.76V1592V1592.48V1600.22V1600.62L260 1605H390L389.95 1592.29Z",
    fill: "#662383"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter68_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.962 1580.22V1579.9V1579.45V1579.19V1490H275L275 1579.45V1579.82V1580V1580.37V1586.32V1586.63L275 1590H375L374.962 1580.22Z",
    fill: "url(#paint68_radial_606_2)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M389.95 1462.29V1461.87V1461.29V1460.95V1345H260L260 1461.29V1461.76V1462V1462.48V1470.22V1470.62L260 1475H390L389.95 1462.29Z",
    fill: "#662383"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter69_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.962 1450.22V1449.9V1449.45V1449.19V1360H275L275 1449.45V1449.82V1450V1450.37V1456.32V1456.63L275 1460H375L374.962 1450.22Z",
    fill: "url(#paint69_radial_606_2)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M259.95 1462.29V1461.87V1461.29V1460.95V1345H130L130 1461.29V1461.76V1462V1462.48V1470.22V1470.62L130 1475H260L259.95 1462.29Z",
    fill: "#662383"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter70_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.962 1450.22V1449.9V1449.45V1449.19V1360H145L145 1449.45V1449.82V1450V1450.37V1456.32V1456.63L145 1460H245L244.962 1450.22Z",
    fill: "url(#paint70_radial_606_2)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M259.95 1592.29V1591.87V1591.29V1590.95V1475H130L130 1591.29V1591.76V1592V1592.48V1600.22V1600.62L130 1605H260L259.95 1592.29Z",
    fill: "#662383"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter71_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.962 1580.22V1579.9V1579.45V1579.19V1490H145L145 1579.45V1579.82V1580V1580.37V1586.32V1586.63L145 1590H245L244.962 1580.22Z",
    fill: "url(#paint71_radial_606_2)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1429.95 2115.29V2114.87V2114.29V2113.95V1998H1300L1300 2114.29V2114.76V2115V2115.48V2123.22V2123.62L1300 2128H1430L1429.95 2115.29Z",
    fill: "#662383"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter72_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1414.96 2103.22V2102.9V2102.45V2102.19V2013H1315L1315 2102.45V2102.82V2103V2103.37V2109.32V2109.63L1315 2113H1415L1414.96 2103.22Z",
    fill: "url(#paint72_radial_606_2)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1559.95 2115.29V2114.87V2114.29V2113.95V1998H1430L1430 2114.29V2114.76V2115V2115.48V2123.22V2123.62L1430 2128H1560L1559.95 2115.29Z",
    fill: "#662383"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter73_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1544.96 2103.22V2102.9V2102.45V2102.19V2013H1445L1445 2102.45V2102.82V2103V2103.37V2109.32V2109.63L1445 2113H1545L1544.96 2103.22Z",
    fill: "url(#paint73_radial_606_2)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1429.95 1985.29V1984.87V1984.29V1983.95V1868H1300L1300 1984.29V1984.76V1985V1985.48V1993.22V1993.62L1300 1998H1430L1429.95 1985.29Z",
    fill: "#662383"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter74_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1414.96 1973.22V1972.9V1972.45V1972.19V1883H1315L1315 1972.45V1972.82V1973V1973.37V1979.32V1979.63L1315 1983H1415L1414.96 1973.22Z",
    fill: "url(#paint74_radial_606_2)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1299.95 2115.29V2114.87V2114.29V2113.95V1998H1170L1170 2114.29V2114.76V2115V2115.48V2123.22V2123.62L1170 2128H1300L1299.95 2115.29Z",
    fill: "#662383"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter75_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1284.96 2103.22V2102.9V2102.45V2102.19V2013H1185L1185 2102.45V2102.82V2103V2103.37V2109.32V2109.63L1185 2113H1285L1284.96 2103.22Z",
    fill: "url(#paint75_radial_606_2)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2189.95 807.29V806.875V806.285V805.946V690H2060L2060 806.285V806.764V807.003V807.482V815.219V815.619L2060 820H2190L2189.95 807.29Z",
    fill: "#662383"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter76_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2174.96 795.223V794.904V794.45V794.189V705H2075L2075 794.45V794.818V795.002V795.371V801.322V801.63L2075 805H2175L2174.96 795.223Z",
    fill: "url(#paint76_radial_606_2)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2319.95 807.29V806.875V806.285V805.946V690H2190L2190 806.285V806.764V807.003V807.482V815.219V815.619L2190 820H2320L2319.95 807.29Z",
    fill: "#662383"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter77_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2304.96 795.223V794.904V794.45V794.189V705H2205L2205 794.45V794.818V795.002V795.371V801.322V801.63L2205 805H2305L2304.96 795.223Z",
    fill: "url(#paint77_radial_606_2)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2319.95 677.29V676.875V676.285V675.946V560H2190L2190 676.285V676.764V677.003V677.482V685.219V685.619L2190 690H2320L2319.95 677.29Z",
    fill: "#662383"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter78_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2304.96 665.223V664.904V664.45V664.189V575H2205L2205 664.45V664.818V665.002V665.371V671.322V671.63L2205 675H2305L2304.96 665.223Z",
    fill: "url(#paint78_radial_606_2)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2189.95 937.29V936.875V936.285V935.946V820H2060L2060 936.285V936.764V937.003V937.482V945.219V945.619L2060 950H2190L2189.95 937.29Z",
    fill: "#662383"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter79_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2174.96 925.223V924.904V924.45V924.189V835H2075L2075 924.45V924.818V925.002V925.371V931.322V931.63L2075 935H2175L2174.96 925.223Z",
    fill: "url(#paint79_radial_606_2)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2067.29 1998.05H2066.87H2066.29H2065.95H1950V2128L2066.29 2128H2066.76H2067H2067.48H2075.22H2075.62L2080 2128V1998L2067.29 1998.05Z",
    fill: "#662383"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter80_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2055.22 2013.04H2054.9H2054.45H2054.19H1965V2113L2054.45 2113H2054.82H2055H2055.37H2061.32H2061.63L2065 2113V2013L2055.22 2013.04Z",
    fill: "url(#paint80_radial_606_2)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2067.29 1868.05H2066.87H2066.29H2065.95H1950V1998L2066.29 1998H2066.76H2067H2067.48H2075.22H2075.62L2080 1998V1868L2067.29 1868.05Z",
    fill: "#662383"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter81_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2055.22 1883.04H2054.9H2054.45H2054.19H1965V1983L2054.45 1983H2054.82H2055H2055.37H2061.32H2061.63L2065 1983V1883L2055.22 1883.04Z",
    fill: "url(#paint81_radial_606_2)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2067.29 1738.05H2066.87H2066.29H2065.95H1950V1868L2066.29 1868H2066.76H2067H2067.48H2075.22H2075.62L2080 1868V1738L2067.29 1738.05Z",
    fill: "#662383"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter82_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2055.22 1753.04H2054.9H2054.45H2054.19H1965V1853L2054.45 1853H2054.82H2055H2055.37H2061.32H2061.63L2065 1853V1753L2055.22 1753.04Z",
    fill: "url(#paint82_radial_606_2)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2067.29 2128.05H2066.87H2066.29H2065.95H1950V2258L2066.29 2258H2066.76H2067H2067.48H2075.22H2075.62L2080 2258V2128L2067.29 2128.05Z",
    fill: "#662383"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter83_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2055.22 2143.04H2054.9H2054.45H2054.19H1965V2243L2054.45 2243H2054.82H2055H2055.37H2061.32H2061.63L2065 2243V2143L2055.22 2143.04Z",
    fill: "url(#paint83_radial_606_2)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1287.29 1348.05H1286.87H1286.29H1285.95H1170V1478L1286.29 1478H1286.76H1287H1287.48H1295.22H1295.62L1300 1478V1348L1287.29 1348.05Z",
    fill: "#662383"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter84_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1275.22 1363.04H1274.9H1274.45H1274.19H1185V1463L1274.45 1463H1274.82H1275H1275.37H1281.32H1281.63L1285 1463V1363L1275.22 1363.04Z",
    fill: "url(#paint84_radial_606_2)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1287.29 1218.05H1286.87H1286.29H1285.95H1170V1348L1286.29 1348H1286.76H1287H1287.48H1295.22H1295.62L1300 1348V1218L1287.29 1218.05Z",
    fill: "#662383"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter85_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1275.22 1233.04H1274.9H1274.45H1274.19H1185V1333L1274.45 1333H1274.82H1275H1275.37H1281.32H1281.63L1285 1333V1233L1275.22 1233.04Z",
    fill: "url(#paint85_radial_606_2)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1287.29 1088.05H1286.87H1286.29H1285.95H1170V1218L1286.29 1218H1286.76H1287H1287.48H1295.22H1295.62L1300 1218V1088L1287.29 1088.05Z",
    fill: "#662383"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter86_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1275.22 1103.04H1274.9H1274.45H1274.19H1185V1203L1274.45 1203H1274.82H1275H1275.37H1281.32H1281.63L1285 1203V1103L1275.22 1103.04Z",
    fill: "url(#paint86_radial_606_2)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1287.29 1478.05H1286.87H1286.29H1285.95H1170V1608L1286.29 1608H1286.76H1287H1287.48H1295.22H1295.62L1300 1608V1478L1287.29 1478.05Z",
    fill: "#662383"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter87_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1275.22 1493.04H1274.9H1274.45H1274.19H1185V1593L1274.45 1593H1274.82H1275H1275.37H1281.32H1281.63L1285 1593V1493L1275.22 1493.04Z",
    fill: "url(#paint87_radial_606_2)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M779.95 1855.29V1854.87V1854.29V1853.95V1738H650L650 1854.29V1854.76V1855V1855.48V1863.22V1863.62L650 1868H780L779.95 1855.29Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter88_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M764.962 1843.22V1842.9V1842.45V1842.19V1753H665L665 1842.45V1842.82V1843V1843.37V1849.32V1849.63L665 1853H765L764.962 1843.22Z",
    fill: "url(#paint88_radial_606_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M909.95 1725.29V1724.87V1724.29V1723.95V1608H780L780 1724.29V1724.76V1725V1725.48V1733.22V1733.62L780 1738H910L909.95 1725.29Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter89_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M894.962 1713.22V1712.9V1712.45V1712.19V1623H795L795 1712.45V1712.82V1713V1713.37V1719.32V1719.63L795 1723H895L894.962 1713.22Z",
    fill: "url(#paint89_radial_606_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M779.95 1595.29V1594.87V1594.29V1593.95V1478H650L650 1594.29V1594.76V1595V1595.48V1603.22V1603.62L650 1608H780L779.95 1595.29Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter90_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M764.962 1583.22V1582.9V1582.45V1582.19V1493H665L665 1582.45V1582.82V1583V1583.37V1589.32V1589.63L665 1593H765L764.962 1583.22Z",
    fill: "url(#paint90_radial_606_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M779.95 1725.29V1724.87V1724.29V1723.95V1608H650L650 1724.29V1724.76V1725V1725.48V1733.22V1733.62L650 1738H780L779.95 1725.29Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter91_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M764.962 1713.22V1712.9V1712.45V1712.19V1623H665L665 1712.45V1712.82V1713V1713.37V1719.32V1719.63L665 1723H765L764.962 1713.22Z",
    fill: "url(#paint91_radial_606_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1027.29 2128.05H1026.87H1026.29H1025.95H910V2258L1026.29 2258H1026.76H1027H1027.48H1035.22H1035.62L1040 2258V2128L1027.29 2128.05Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter92_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1015.22 2143.04H1014.9H1014.45H1014.19H925V2243L1014.45 2243H1014.82H1015H1015.37H1021.32H1021.63L1025 2243V2143L1015.22 2143.04Z",
    fill: "url(#paint92_radial_606_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1157.29 2128.05H1156.87H1156.29H1155.95H1040V2258L1156.29 2258H1156.76H1157H1157.48H1165.22H1165.62L1170 2258V2128L1157.29 2128.05Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter93_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1145.22 2143.04H1144.9H1144.45H1144.19H1055V2243L1144.45 2243H1144.82H1145H1145.37H1151.32H1151.63L1155 2243V2143L1145.22 2143.04Z",
    fill: "url(#paint93_radial_606_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1027.29 1868.05H1026.87H1026.29H1025.95H910V1998L1026.29 1998H1026.76H1027H1027.48H1035.22H1035.62L1040 1998V1868L1027.29 1868.05Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter94_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1015.22 1883.04H1014.9H1014.45H1014.19H925V1983L1014.45 1983H1014.82H1015H1015.37H1021.32H1021.63L1025 1983V1883L1015.22 1883.04Z",
    fill: "url(#paint94_radial_606_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M897.29 1998.05H896.875H896.285H895.946H780V2128L896.285 2128H896.764H897.003H897.482H905.219H905.619L910 2128V1998L897.29 1998.05Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter95_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M885.223 2013.04H884.904H884.45H884.189H795V2113L884.45 2113H884.818H885.002H885.371H891.322H891.63L895 2113V2013L885.223 2013.04Z",
    fill: "url(#paint95_radial_606_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1027.29 1998.05H1026.87H1026.29H1025.95H910V2128L1026.29 2128H1026.76H1027H1027.48H1035.22H1035.62L1040 2128V1998L1027.29 1998.05Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter96_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1015.22 2013.04H1014.9H1014.45H1014.19H925V2113L1014.45 2113H1014.82H1015H1015.37H1021.32H1021.63L1025 2113V2013L1015.22 2013.04Z",
    fill: "url(#paint96_radial_606_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M897.29 1868.05H896.875H896.285H895.946H780V1998L896.285 1998H896.764H897.003H897.482H905.219H905.619L910 1998V1868L897.29 1868.05Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter97_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M885.223 1883.04H884.904H884.45H884.189H795V1983L884.45 1983H884.818H885.002H885.371H891.322H891.63L895 1983V1883L885.223 1883.04Z",
    fill: "url(#paint97_radial_606_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M767.29 2128.05H766.875H766.285H765.946H650V2258L766.285 2258H766.764H767.003H767.482H775.219H775.619L780 2258V2128L767.29 2128.05Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter98_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M755.223 2143.04H754.904H754.45H754.189H665V2243L754.45 2243H754.818H755.002H755.371H761.322H761.63L765 2243V2143L755.223 2143.04Z",
    fill: "url(#paint98_radial_606_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M897.29 2128.05H896.875H896.285H895.946H780V2258L896.285 2258H896.764H897.003H897.482H905.219H905.619L910 2258V2128L897.29 2128.05Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter99_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M885.223 2143.04H884.904H884.45H884.189H795V2243L884.45 2243H884.818H885.002H885.371H891.322H891.63L895 2243V2143L885.223 2143.04Z",
    fill: "url(#paint99_radial_606_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2597.29 1280.05H2596.87H2596.29H2595.95H2480V1410L2596.29 1410H2596.76H2597H2597.48H2605.22H2605.62L2610 1410V1280L2597.29 1280.05Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter100_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2585.22 1295.04H2584.9H2584.45H2584.19H2495V1395L2584.45 1395H2584.82H2585H2585.37H2591.32H2591.63L2595 1395V1295L2585.22 1295.04Z",
    fill: "url(#paint100_radial_606_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2727.29 1280.05H2726.87H2726.29H2725.95H2610V1410L2726.29 1410H2726.76H2727H2727.48H2735.22H2735.62L2740 1410V1280L2727.29 1280.05Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter101_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2715.22 1295.04H2714.9H2714.45H2714.19H2625V1395L2714.45 1395H2714.82H2715H2715.37H2721.32H2721.63L2725 1395V1295L2715.22 1295.04Z",
    fill: "url(#paint101_radial_606_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2337.29 1280.05H2336.87H2336.29H2335.95H2220V1410L2336.29 1410H2336.76H2337H2337.48H2345.22H2345.62L2350 1410V1280L2337.29 1280.05Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter102_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2325.22 1295.04H2324.9H2324.45H2324.19H2235V1395L2324.45 1395H2324.82H2325H2325.37H2331.32H2331.63L2335 1395V1295L2325.22 1295.04Z",
    fill: "url(#paint102_radial_606_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2467.29 1280.05H2466.87H2466.29H2465.95H2350V1410L2466.29 1410H2466.76H2467H2467.48H2475.22H2475.62L2480 1410V1280L2467.29 1280.05Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter103_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2455.22 1295.04H2454.9H2454.45H2454.19H2365V1395L2454.45 1395H2454.82H2455H2455.37H2461.32H2461.63L2465 1395V1295L2455.22 1295.04Z",
    fill: "url(#paint103_radial_606_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1757.29 330.05H1756.87H1756.29H1755.95H1640V460L1756.29 460H1756.76H1757H1757.48H1765.22H1765.62L1770 460V330L1757.29 330.05Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter104_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1745.22 345.038H1744.9H1744.45H1744.19H1655V445L1744.45 445H1744.82H1745H1745.37H1751.32H1751.63L1755 445V345L1745.22 345.038Z",
    fill: "url(#paint104_radial_606_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1757.29 460.05H1756.87H1756.29H1755.95H1640V590L1756.29 590H1756.76H1757H1757.48H1765.22H1765.62L1770 590V460L1757.29 460.05Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter105_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1745.22 475.038H1744.9H1744.45H1744.19H1655V575L1744.45 575H1744.82H1745H1745.37H1751.32H1751.63L1755 575V475L1745.22 475.038Z",
    fill: "url(#paint105_radial_606_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1497.29 330.05H1496.87H1496.29H1495.95H1380V460L1496.29 460H1496.76H1497H1497.48H1505.22H1505.62L1510 460V330L1497.29 330.05Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter106_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1485.22 345.038H1484.9H1484.45H1484.19H1395V445L1484.45 445H1484.82H1485H1485.37H1491.32H1491.63L1495 445V345L1485.22 345.038Z",
    fill: "url(#paint106_radial_606_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1627.29 330.05H1626.87H1626.29H1625.95H1510V460L1626.29 460H1626.76H1627H1627.48H1635.22H1635.62L1640 460V330L1627.29 330.05Z",
    fill: "#DEDC00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter107_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1615.22 345.038H1614.9H1614.45H1614.19H1525V445L1614.45 445H1614.82H1615H1615.37H1621.32H1621.63L1625 445V345L1615.22 345.038Z",
    fill: "url(#paint107_radial_606_2)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1169.95 1855.29V1854.87V1854.29V1853.95V1738H1040L1040 1854.29V1854.76V1855V1855.48V1863.22V1863.62L1040 1868H1170L1169.95 1855.29Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter108_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1154.96 1843.22V1842.9V1842.45V1842.19V1753H1055L1055 1842.45V1842.82V1843V1843.37V1849.32V1849.63L1055 1853H1155L1154.96 1843.22Z",
    fill: "url(#paint108_radial_606_2)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1169.95 1985.29V1984.87V1984.29V1983.95V1868H1040L1040 1984.29V1984.76V1985V1985.48V1993.22V1993.62L1040 1998H1170L1169.95 1985.29Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter109_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1154.96 1973.22V1972.9V1972.45V1972.19V1883H1055L1055 1972.45V1972.82V1973V1973.37V1979.32V1979.63L1055 1983H1155L1154.96 1973.22Z",
    fill: "url(#paint109_radial_606_2)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1169.95 1725.29V1724.87V1724.29V1723.95V1608H1040L1040 1724.29V1724.76V1725V1725.48V1733.22V1733.62L1040 1738H1170L1169.95 1725.29Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter110_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1154.96 1713.22V1712.9V1712.45V1712.19V1623H1055L1055 1712.45V1712.82V1713V1713.37V1719.32V1719.63L1055 1723H1155L1154.96 1713.22Z",
    fill: "url(#paint110_radial_606_2)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1169.95 2115.29V2114.87V2114.29V2113.95V1998H1040L1040 2114.29V2114.76V2115V2115.48V2123.22V2123.62L1040 2128H1170L1169.95 2115.29Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter111_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1154.96 2103.22V2102.9V2102.45V2102.19V2013H1055L1055 2102.45V2102.82V2103V2103.37V2109.32V2109.63L1055 2113H1155L1154.96 2103.22Z",
    fill: "url(#paint111_radial_606_2)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M377.29 2128.05H376.875H376.285H375.946H260V2258L376.285 2258H376.764H377.003H377.482H385.219H385.619L390 2258V2128L377.29 2128.05Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter112_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.223 2143.04H364.904H364.45H364.189H275V2243L364.45 2243H364.818H365.002H365.371H371.322H371.63L375 2243V2143L365.223 2143.04Z",
    fill: "url(#paint112_radial_606_2)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M507.29 2128.05H506.875H506.285H505.946H390V2258L506.285 2258H506.764H507.003H507.482H515.219H515.619L520 2258V2128L507.29 2128.05Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter113_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M495.223 2143.04H494.904H494.45H494.189H405V2243L494.45 2243H494.818H495.002H495.371H501.322H501.63L505 2243V2143L495.223 2143.04Z",
    fill: "url(#paint113_radial_606_2)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M247.29 2128.05H246.875H246.285H245.946H130V2258L246.285 2258H246.764H247.003H247.482H255.219H255.619L260 2258V2128L247.29 2128.05Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter114_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.223 2143.04H234.904H234.45H234.189H145V2243L234.45 2243H234.818H235.002H235.371H241.322H241.63L245 2243V2143L235.223 2143.04Z",
    fill: "url(#paint114_radial_606_2)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M637.29 2128.05H636.875H636.285H635.946H520V2258L636.285 2258H636.764H637.003H637.482H645.219H645.619L650 2258V2128L637.29 2128.05Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter115_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M625.223 2143.04H624.904H624.45H624.189H535V2243L624.45 2243H624.818H625.002H625.371H631.322H631.63L635 2243V2143L625.223 2143.04Z",
    fill: "url(#paint115_radial_606_2)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1819.95 1985.29V1984.87V1984.29V1983.95V1868H1690L1690 1984.29V1984.76V1985V1985.48V1993.22V1993.62L1690 1998H1820L1819.95 1985.29Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter116_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1804.96 1973.22V1972.9V1972.45V1972.19V1883H1705L1705 1972.45V1972.82V1973V1973.37V1979.32V1979.63L1705 1983H1805L1804.96 1973.22Z",
    fill: "url(#paint116_radial_606_2)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1819.95 2115.29V2114.87V2114.29V2113.95V1998H1690L1690 2114.29V2114.76V2115V2115.48V2123.22V2123.62L1690 2128H1820L1819.95 2115.29Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter117_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1804.96 2103.22V2102.9V2102.45V2102.19V2013H1705L1705 2102.45V2102.82V2103V2103.37V2109.32V2109.63L1705 2113H1805L1804.96 2103.22Z",
    fill: "url(#paint117_radial_606_2)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1949.95 1985.29V1984.87V1984.29V1983.95V1868H1820L1820 1984.29V1984.76V1985V1985.48V1993.22V1993.62L1820 1998H1950L1949.95 1985.29Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter118_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1934.96 1973.22V1972.9V1972.45V1972.19V1883H1835L1835 1972.45V1972.82V1973V1973.37V1979.32V1979.63L1835 1983H1935L1934.96 1973.22Z",
    fill: "url(#paint118_radial_606_2)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1949.95 2115.29V2114.87V2114.29V2113.95V1998H1820L1820 2114.29V2114.76V2115V2115.48V2123.22V2123.62L1820 2128H1950L1949.95 2115.29Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter119_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1934.96 2103.22V2102.9V2102.45V2102.19V2013H1835L1835 2102.45V2102.82V2103V2103.37V2109.32V2109.63L1835 2113H1935L1934.96 2103.22Z",
    fill: "url(#paint119_radial_606_2)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1039.95 1332.29V1331.87V1331.29V1330.95V1215H910L910 1331.29V1331.76V1332V1332.48V1340.22V1340.62L910 1345H1040L1039.95 1332.29Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter120_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1024.96 1320.22V1319.9V1319.45V1319.19V1230H925L925 1319.45V1319.82V1320V1320.37V1326.32V1326.63L925 1330H1025L1024.96 1320.22Z",
    fill: "url(#paint120_radial_606_2)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1039.95 1462.29V1461.87V1461.29V1460.95V1345H910L910 1461.29V1461.76V1462V1462.48V1470.22V1470.62L910 1475H1040L1039.95 1462.29Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter121_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1024.96 1450.22V1449.9V1449.45V1449.19V1360H925L925 1449.45V1449.82V1450V1450.37V1456.32V1456.63L925 1460H1025L1024.96 1450.22Z",
    fill: "url(#paint121_radial_606_2)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1169.95 1332.29V1331.87V1331.29V1330.95V1215H1040L1040 1331.29V1331.76V1332V1332.48V1340.22V1340.62L1040 1345H1170L1169.95 1332.29Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter122_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1154.96 1320.22V1319.9V1319.45V1319.19V1230H1055L1055 1319.45V1319.82V1320V1320.37V1326.32V1326.63L1055 1330H1155L1154.96 1320.22Z",
    fill: "url(#paint122_radial_606_2)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1169.95 1462.29V1461.87V1461.29V1460.95V1345H1040L1040 1461.29V1461.76V1462V1462.48V1470.22V1470.62L1040 1475H1170L1169.95 1462.29Z",
    fill: "#DA8300"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter123_f_606_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1154.96 1450.22V1449.9V1449.45V1449.19V1360H1055L1055 1449.45V1449.82V1450V1450.37V1456.32V1456.63L1055 1460H1155L1154.96 1450.22Z",
    fill: "url(#paint123_radial_606_2)",
    fillOpacity: 0.6
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_606_2",
    x: 1439,
    y: 1323,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_606_2",
    x: 1699,
    y: 1193,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_606_2",
    x: 1569,
    y: 1193,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_606_2",
    x: 1439,
    y: 1193,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_606_2",
    x: 1439,
    y: 1453,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_606_2",
    x: 1309,
    y: 1193,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_606_2",
    x: 1439,
    y: 1583,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_606_2",
    x: 1829,
    y: 1193,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_606_2",
    x: 749,
    y: 539,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_606_2",
    x: 749,
    y: 409,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_606_2",
    x: 749,
    y: 669,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_606_2",
    x: 619,
    y: 409,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_606_2",
    x: 139,
    y: 2007,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_606_2",
    x: 9,
    y: 1747,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_606_2",
    x: 9,
    y: 1877,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_606_2",
    x: 9,
    y: 2007,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_f_606_2",
    x: 269,
    y: 2007,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_f_606_2",
    x: 9,
    y: 2137,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_f_606_2",
    x: 399,
    y: 2007,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_f_606_2",
    x: 9,
    y: 1617,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_f_606_2",
    x: 1569,
    y: 1583,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_f_606_2",
    x: 1699,
    y: 1583,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_f_606_2",
    x: 1829,
    y: 1583,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_f_606_2",
    x: 1959,
    y: 1583,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_f_606_2",
    x: 1699,
    y: 1713,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_f_606_2",
    x: 1829,
    y: 1713,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_f_606_2",
    x: 2649,
    y: 399,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_f_606_2",
    x: 2649,
    y: 269,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_f_606_2",
    x: 2649,
    y: 139,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_f_606_2",
    x: 2649,
    y: 9,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_f_606_2",
    x: 2779,
    y: 269,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_f_606_2",
    x: 2909,
    y: 269,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_f_606_2",
    x: 2779,
    y: 139,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter33_f_606_2",
    x: 2909,
    y: 139,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter34_f_606_2",
    x: 399,
    y: 1877,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter35_f_606_2",
    x: 529,
    y: 1877,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter36_f_606_2",
    x: 659,
    y: 1877,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter37_f_606_2",
    x: 529,
    y: 2007,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter38_f_606_2",
    x: 659,
    y: 2007,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter39_f_606_2",
    x: 1049,
    y: 749,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter40_f_606_2",
    x: 1179,
    y: 749,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter41_f_606_2",
    x: 1309,
    y: 749,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter42_f_606_2",
    x: 1179,
    y: 879,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter43_f_606_2",
    x: 1569,
    y: 2007,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter44_f_606_2",
    x: 1569,
    y: 1747,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter45_f_606_2",
    x: 1569,
    y: 1877,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter46_f_606_2",
    x: 1179,
    y: 2137,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter47_f_606_2",
    x: 1309,
    y: 2137,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter48_f_606_2",
    x: 1439,
    y: 2137,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter49_f_606_2",
    x: 1697,
    y: 2137,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter50_f_606_2",
    x: 1569,
    y: 2137,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter51_f_606_2",
    x: 399,
    y: 1189,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter52_f_606_2",
    x: 139,
    y: 1189,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter53_f_606_2",
    x: 269,
    y: 1189,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter54_f_606_2",
    x: 529,
    y: 799,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter55_f_606_2",
    x: 529,
    y: 929,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter56_f_606_2",
    x: 529,
    y: 1059,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter57_f_606_2",
    x: 529,
    y: 1317,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter58_f_606_2",
    x: 529,
    y: 1189,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter59_f_606_2",
    x: 919,
    y: 1617,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter60_f_606_2",
    x: 789,
    y: 1747,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter61_f_606_2",
    x: 919,
    y: 1747,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter62_f_606_2",
    x: 1049,
    y: 1487,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter63_f_606_2",
    x: 919,
    y: 1487,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter64_f_606_2",
    x: 1859,
    y: 839,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter65_f_606_2",
    x: 1729,
    y: 969,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter66_f_606_2",
    x: 1859,
    y: 969,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter67_f_606_2",
    x: 1729,
    y: 839,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter68_f_606_2",
    x: 269,
    y: 1484,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter69_f_606_2",
    x: 269,
    y: 1354,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter70_f_606_2",
    x: 139,
    y: 1354,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter71_f_606_2",
    x: 139,
    y: 1484,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter72_f_606_2",
    x: 1309,
    y: 2007,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter73_f_606_2",
    x: 1439,
    y: 2007,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter74_f_606_2",
    x: 1309,
    y: 1877,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter75_f_606_2",
    x: 1179,
    y: 2007,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter76_f_606_2",
    x: 2069,
    y: 699,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter77_f_606_2",
    x: 2199,
    y: 699,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter78_f_606_2",
    x: 2199,
    y: 569,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter79_f_606_2",
    x: 2069,
    y: 829,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter80_f_606_2",
    x: 1959,
    y: 2007,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter81_f_606_2",
    x: 1959,
    y: 1877,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter82_f_606_2",
    x: 1959,
    y: 1747,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter83_f_606_2",
    x: 1959,
    y: 2137,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter84_f_606_2",
    x: 1179,
    y: 1357,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter85_f_606_2",
    x: 1179,
    y: 1227,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter86_f_606_2",
    x: 1179,
    y: 1097,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter87_f_606_2",
    x: 1179,
    y: 1487,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter88_f_606_2",
    x: 659,
    y: 1747,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter89_f_606_2",
    x: 789,
    y: 1617,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter90_f_606_2",
    x: 659,
    y: 1487,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter91_f_606_2",
    x: 659,
    y: 1617,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter92_f_606_2",
    x: 919,
    y: 2137,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter93_f_606_2",
    x: 1049,
    y: 2137,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter94_f_606_2",
    x: 919,
    y: 1877,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter95_f_606_2",
    x: 789,
    y: 2007,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter96_f_606_2",
    x: 919,
    y: 2007,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter97_f_606_2",
    x: 789,
    y: 1877,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter98_f_606_2",
    x: 659,
    y: 2137,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter99_f_606_2",
    x: 789,
    y: 2137,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter100_f_606_2",
    x: 2489,
    y: 1289,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter101_f_606_2",
    x: 2619,
    y: 1289,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter102_f_606_2",
    x: 2229,
    y: 1289,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter103_f_606_2",
    x: 2359,
    y: 1289,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter104_f_606_2",
    x: 1649,
    y: 339,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter105_f_606_2",
    x: 1649,
    y: 469,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter106_f_606_2",
    x: 1389,
    y: 339,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter107_f_606_2",
    x: 1519,
    y: 339,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter108_f_606_2",
    x: 1049,
    y: 1747,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter109_f_606_2",
    x: 1049,
    y: 1877,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter110_f_606_2",
    x: 1049,
    y: 1617,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter111_f_606_2",
    x: 1049,
    y: 2007,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter112_f_606_2",
    x: 269,
    y: 2137,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter113_f_606_2",
    x: 399,
    y: 2137,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter114_f_606_2",
    x: 139,
    y: 2137,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter115_f_606_2",
    x: 529,
    y: 2137,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter116_f_606_2",
    x: 1699,
    y: 1877,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter117_f_606_2",
    x: 1699,
    y: 2007,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter118_f_606_2",
    x: 1829,
    y: 1877,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter119_f_606_2",
    x: 1829,
    y: 2007,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter120_f_606_2",
    x: 919,
    y: 1224,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter121_f_606_2",
    x: 919,
    y: 1354,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter122_f_606_2",
    x: 1049,
    y: 1224,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter123_f_606_2",
    x: 1049,
    y: 1354,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_606_2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1498 1379.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1758 1249.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1628 1249.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1498 1249.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1498 1509.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1368 1249.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1498 1639.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1888 1249.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(808 595.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(808 465.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(808 725.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(678 465.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(195.5 2060) rotate(112.714) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.5 1800) rotate(112.714) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.5 1930) rotate(112.714) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.5 2060) rotate(112.714) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(325.5 2060) rotate(112.714) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.5 2190) rotate(112.714) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(455.5 2060) rotate(112.714) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.5 1670) rotate(112.714) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37AAE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1628 1639.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1758 1639.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1888 1639.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2018 1639.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1758 1769.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1888 1769.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2705.5 452) rotate(112.714) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2705.5 322) rotate(112.714) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2705.5 192) rotate(112.714) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2705.5 62) rotate(112.714) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2835.5 322) rotate(112.714) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2965.5 322) rotate(112.714) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2835.5 192) rotate(112.714) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2965.5 192) rotate(112.714) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(458 1933.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(588 1933.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(718 1933.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(588 2063.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(718 2063.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1108 805.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1238 805.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1368 805.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1238 935.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1628 2063.5) rotate(-150.604) scale(81.4923 75.9778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1628 1803.5) rotate(-150.604) scale(81.4923 75.9778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1628 1933.5) rotate(-150.604) scale(81.4923 75.9778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1238 2193.5) rotate(-150.604) scale(81.4923 75.9778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1368 2193.5) rotate(-150.604) scale(81.4923 75.9778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1498 2193.5) rotate(-150.604) scale(81.4923 75.9778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1756 2193.5) rotate(-150.604) scale(81.4923 75.9778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1628 2193.5) rotate(-150.604) scale(81.4923 75.9778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(455.5 1248) rotate(-119.396) scale(81.4923 75.9778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(195.5 1248) rotate(-119.396) scale(81.4923 75.9778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(325.5 1248) rotate(-119.396) scale(81.4923 75.9778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(585.5 858) rotate(-119.396) scale(81.4923 75.9778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(585.5 988) rotate(-119.396) scale(81.4923 75.9778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(585.5 1118) rotate(-119.396) scale(81.4923 75.9778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(585.5 1376) rotate(-119.396) scale(81.4923 75.9778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(585.5 1248) rotate(-119.396) scale(81.4923 75.9778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(978 1672.5) rotate(150.604) scale(81.4923 75.9778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(848 1802.5) rotate(150.604) scale(81.4923 75.9778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(978 1802.5) rotate(150.604) scale(81.4923 75.9778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1108 1542.5) rotate(150.604) scale(81.4923 75.9778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(978 1542.5) rotate(150.604) scale(81.4923 75.9778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1918 894.5) rotate(150.604) scale(81.4923 75.9778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1788 1024.5) rotate(150.604) scale(81.4923 75.9778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1918 1024.5) rotate(150.604) scale(81.4923 75.9778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1788 894.5) rotate(150.604) scale(81.4923 75.9778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71E73"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(328 1540.5) rotate(-157.41) scale(74.1923 69.1717)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662383"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(328 1410.5) rotate(-157.41) scale(74.1923 69.1717)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662383"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(198 1410.5) rotate(-157.41) scale(74.1923 69.1717)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662383"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(198 1540.5) rotate(-157.41) scale(74.1923 69.1717)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662383"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1368 2063.5) rotate(-157.41) scale(74.1923 69.1717)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662383"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1498 2063.5) rotate(-157.41) scale(74.1923 69.1717)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662383"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1368 1933.5) rotate(-157.41) scale(74.1923 69.1717)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662383"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1238 2063.5) rotate(-157.41) scale(74.1923 69.1717)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662383"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2128 755.5) rotate(-157.41) scale(74.1923 69.1717)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662383"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2258 755.5) rotate(-157.41) scale(74.1923 69.1717)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662383"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2258 625.5) rotate(-157.41) scale(74.1923 69.1717)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662383"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2128 885.5) rotate(-157.41) scale(74.1923 69.1717)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662383"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2015.5 2060) rotate(112.59) scale(74.1923 69.1717)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662383"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2015.5 1930) rotate(112.59) scale(74.1923 69.1717)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662383"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2015.5 1800) rotate(112.59) scale(74.1923 69.1717)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662383"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2015.5 2190) rotate(112.59) scale(74.1923 69.1717)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662383"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1235.5 1410) rotate(112.59) scale(74.1923 69.1717)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662383"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1235.5 1280) rotate(112.59) scale(74.1923 69.1717)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662383"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1235.5 1150) rotate(112.59) scale(74.1923 69.1717)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662383"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1235.5 1540) rotate(112.59) scale(74.1923 69.1717)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662383"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(718 1803.5) rotate(-152.091) scale(123.912 115.527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(848 1673.5) rotate(-152.091) scale(123.912 115.527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(718 1543.5) rotate(-152.091) scale(123.912 115.527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(718 1673.5) rotate(-152.091) scale(123.912 115.527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(975.5 2190) rotate(117.909) scale(123.912 115.527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1105.5 2190) rotate(117.909) scale(123.912 115.527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(975.5 1930) rotate(117.909) scale(123.912 115.527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(845.5 2060) rotate(117.909) scale(123.912 115.527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(975.5 2060) rotate(117.909) scale(123.912 115.527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(845.5 1930) rotate(117.909) scale(123.912 115.527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(715.5 2190) rotate(117.909) scale(123.912 115.527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(845.5 2190) rotate(117.909) scale(123.912 115.527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2545.5 1342) rotate(117.909) scale(123.912 115.527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2675.5 1342) rotate(117.909) scale(123.912 115.527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2285.5 1342) rotate(117.909) scale(123.912 115.527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2415.5 1342) rotate(117.909) scale(123.912 115.527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1705.5 392) rotate(117.909) scale(123.912 115.527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1705.5 522) rotate(117.909) scale(123.912 115.527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1445.5 392) rotate(117.909) scale(123.912 115.527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1575.5 392) rotate(117.909) scale(123.912 115.527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDC00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1108 1803.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1108 1933.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1108 1673.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1108 2063.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(325.5 2190) rotate(112.714) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(455.5 2190) rotate(112.714) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(195.5 2190) rotate(112.714) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(585.5 2190) rotate(112.714) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1758 1933.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1758 2063.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1888 1933.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1888 2063.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(978 1280.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(978 1410.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1108 1280.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_606_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1108 1410.5) rotate(-157.286) scale(93.2309 86.922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_606_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3030,
    height: 2258,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePageImage3);
export default __webpack_public_path__ + "static/media/home-page-image3.056619035f29ae10a36e15503c5f148b.svg";
export { ForwardRef as ReactComponent };